import React from "react";
import { baseURL } from "../../api";
import { useHistory, useParams } from "react-router-dom";
import { Labeling } from "@bimify-ab/labeling-tool";
import { getToken } from "../../utils/local-storage.util";
import config from "../../config";

const LabelingTool = (props) => {
	const { jobId, disciplineId } = useParams();
	const history = useHistory();

	return (
		<>
			<Labeling
				baseURL={baseURL}
				socketURL={config.api.socketUrl}
				jobId={jobId}
				disciplineId={disciplineId}
				accessToken={getToken()}
				onCancel={() => history.goBack()}
			/>
		</>
	);
};

export default LabelingTool;
